import React, { useEffect, useMemo, useState } from "react";
import { Alert, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { getMySubscriptions } from "../../services/subscriptionService";

const formatDate = (value) =>
  value ? new Date(value).toLocaleDateString("es-ES") : null;

export default function LicenseStatusBanner() {
  const { isAuthenticated, user } = useAuth();
  const navigate = useNavigate();
  const [subscriptions, setSubscriptions] = useState([]);

  useEffect(() => {
    if (!isAuthenticated || user?.rol === "admin") {
      setSubscriptions([]);
      return undefined;
    }

    let active = true;
    getMySubscriptions()
      .then((items) => {
        if (active) setSubscriptions(items);
      })
      .catch((error) => {
        console.error("No se pudo consultar el estado de la licencia:", error);
      });
    return () => {
      active = false;
    };
  }, [isAuthenticated, user?.rol]);

  const notice = useMemo(() => {
    const trial = subscriptions.find(
      (item) => item.plan_key === "trial-full"
        && item.status === "trialing"
        && Date.parse(item.current_period_end || "") > Date.now()
    );
    if (trial) {
      return {
        severity: "info",
        text: `Estás disfrutando de la prueba gratuita con acceso completo hasta ${formatDate(trial.current_period_end)}. Después podrás elegir la licencia que mejor encaje contigo.`,
      };
    }

    const pastDue = subscriptions.find((item) => item.status === "past_due");
    if (pastDue) {
      return {
        severity: "warning",
        text: `No se ha podido cobrar tu licencia. Mantienes acceso durante el periodo de gracia${formatDate(pastDue.current_period_end) ? ` iniciado el ${formatDate(pastDue.current_period_end)}` : ""}. Actualiza el pago para evitar restricciones.`,
      };
    }

    const canceling = subscriptions.find(
      (item) => ["active", "trialing"].includes(item.status) && item.cancel_at_period_end
    );
    if (canceling) {
      return {
        severity: "info",
        text: `Tu licencia seguirá activa hasta ${formatDate(canceling.current_period_end) || "el final del periodo contratado"}.`,
      };
    }
    return null;
  }, [subscriptions]);

  if (!notice) return null;

  return (
    <Alert
      severity={notice.severity}
      action={
        <Button color="inherit" size="small" onClick={() => navigate("/mis-licencias")}>
          Gestionar
        </Button>
      }
      sx={{ borderRadius: 0 }}
    >
      {notice.text}
    </Alert>
  );
}
